export default "__VITE_ASSET__BRoDfKUV__"